import { stylePropsAll } from "@tamagui/helpers";
import { createComponent } from "./createComponent.js";
import { ReactNativeStaticConfigs } from "./setupReactNative.js";
function styled(Component, options, staticExtractionOptions) {
  if (process.env.NODE_ENV !== "production") {
    if (!Component) {
      throw new Error(`No component given to styled()`);
    }
    if (options == null ? void 0 : options.variants) {
      for (const key in options.variants) {
        if (key in stylePropsAll) {
          console.error(
            `Invalid variant key overlaps with style key: ${key}. Tamagui prevents defining variants that use valid style keys to reduce implementation complexity.`
          );
        }
      }
    }
  }
  const parentStaticConfig = "staticConfig" in Component ? Component.staticConfig : null;
  const isTamagui = !!parentStaticConfig;
  const isReactNative = Boolean(
    ReactNativeStaticConfigs.has(Component) || (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isReactNative) || ReactNativeStaticConfigs.has(parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isReactNative)
  );
  const staticConfigProps = (() => {
    if (options) {
      const {
        variants,
        name,
        defaultVariants,
        acceptsClassName: acceptsClassNameProp,
        ...defaultProps
      } = options;
      if (defaultVariants) {
        Object.assign(defaultProps, defaultVariants);
      }
      const Comp = isReactNative ? (parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || Component : Component;
      const nativeConf = isReactNative && ReactNativeStaticConfigs.get(Comp) || null;
      const isText = Boolean(
        (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isText) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isText)
      );
      const acceptsClassName = acceptsClassNameProp ?? (isTamagui || isReactNative);
      const conf = {
        ...staticExtractionOptions,
        ...!isTamagui && {
          Component: Comp
        },
        // this type gets messed up by options?: Partial<GetProps<ParentComponent>> above
        // take away the Partial<> and it's fine
        variants,
        defaultProps,
        defaultVariants,
        componentName: name,
        isReactNative,
        isText,
        acceptsClassName,
        ...nativeConf
      };
      if (defaultProps.children || !acceptsClassName) {
        conf.neverFlatten = true;
      }
      return conf;
    }
  })();
  const component = createComponent(staticConfigProps || {}, Component);
  return component;
}
export {
  styled
};
//# sourceMappingURL=styled.js.map
